module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_ic"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I am not a great man, but sometimes I think the impersonal and objective quality of my talent, and the sacrifices of it, in pieces, to preserve its essential value has some sort of epic grandeur.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm1"
  }, [_vm._v("—F. Scott Fitzgerald")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4331af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dadication.vue
// module id = 66
// module chunks = 0